export function arraysAreEqual(a, b, cmpFn = Object.is) {
  return a.length === b.length && a.every((elem, idx) => cmpFn(elem, b[idx]));
}
